import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import Menu from './Menu';
import {classNames} from 'primereact/utils';
import settings from '../../config/settings';
import {RootState} from '../../redux/store';

const Topbar = (props: any) => {
    const onTopbarSubItemClick = (event: any) => {
        event.preventDefault();
    };

    const navigate = useNavigate();
    const selectedProject = useSelector((state: RootState) => state.project.selectedProject);

    const isOverlay = () => {
        return props.menuMode === 'overlay';
    };

    const isSidebar = () => {
        return props.menuMode === 'sidebar';
    };

    return (
        <>
            <div className="layout-topbar">
                <button
                    className="ancorelog-menu-button p-link"
                    aria-label="Toggle menu"
                    onClick={props.onMenuButtonClick}>
                    <i className="pi pi-bars"></i>
                </button>
                <img
                    className={'ancorelog-logo'}
                    src={'/ancorelog-logo.png'} alt='ANCORELOG logo'
                    onClick={() => navigate('/#projects')}/>
                <div className={'menu-logo block'}>
                    <button className={'p-link app-logo'}>
                        <img
                            src={'/logo-dark.png'} alt='APP logo'
                            onClick={() => navigate('/#projects')}/>
                    </button>
                    {/* <button className="app-name p-link">*/}
                    {/*    <img src={window.location.origin + '/logo-dmt-new.png'} alt="app-name" onClick={() => navigate('/')} />*/}
                    {/* </button>*/}
                </div>

                {selectedProject && (
                    <div
                        className="layout-topbar-project-name flex align-items-center"
                        title={selectedProject.name}
                    >
                        <span style={{fontWeight: 600, fontSize: '1.05rem', whiteSpace: 'nowrap'}}>
                            {selectedProject.name}
                        </span>
                    </div>
                )}
                {/* <div className="layout-topbar-left">*/}
                {/*    <button className="topbar-menu-button p-link" onClick={props.onMenuButtonClick}>*/}
                {/*        <i className="pi pi-bars"></i>*/}
                {/*    </button>*/}

                {/*    <button className="logo p-link" onClick={() => navigate('/')}>*/}
                {/*        <img src={`assets/layout/images/logo-${props.colorScheme === 'light' ? 'dark' : 'light'}.png`} alt="logo" />*/}
                {/*    </button>*/}

                {/*    <button className="p-link" onClick={() => navigate('/')}>*/}
                {/*        <img src={`assets/layout/images/appname-${props.colorScheme === 'light' ? 'dark' : 'light'}.png`} className="app-name" alt="app-name" />*/}
                {/*    </button>*/}
                {/* </div>*/}
                {/* <Menu*/}
                {/*    model={props.items}*/}
                {/*    menuMode={props.menuMode}*/}
                {/*    colorScheme={props.colorScheme}*/}
                {/*    menuActive={props.menuActive}*/}
                {/*    activeInlineProfile={props.activeInlineProfile}*/}
                {/*    onSidebarMouseOver={props.onSidebarMouseOver}*/}
                {/*    onSidebarMouseLeave={props.onSidebarMouseLeave}*/}
                {/*    toggleMenu={props.onToggleMenu}*/}
                {/*    onChangeActiveInlineMenu={props.onChangeActiveInlineMenu}*/}
                {/*    onMenuClick={props.onMenuClick}*/}
                {/*    onRootMenuItemClick={props.onRootMenuItemClick}*/}
                {/*    onMenuItemClick={props.onMenuItemClick}*/}
                {/* />*/}
            </div>
        </>
    );
};

export default Topbar;
